<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-label>{{ 'i18n.orderStatusPage.filter' | translate }} </ion-label>
    <ion-badge *ngIf="selectedFiltersSummary['total']">
      {{ selectedFiltersSummary['total'] }}
    </ion-badge>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-mobile">
  <div class="my-orders-filter-options">
    <ion-item-divider></ion-item-divider>
    <ion-item
      *ngFor="let filterKey of getFiltersKeys()"
      detail
      (click)="onFilterSelected(filterKey)"
    >
      <ion-label
        [ngClass]="selectedFilter === filterKey ? 'selected-filter-label' : ''"
        translate
      >
        {{ filters[filterKey].displayName }}
        <span
          *ngIf="
            selectedFiltersSummary[filterKey] !== undefined &&
            filterKey !== 'deliveryDate'
          "
        >
          {{ 'i18n.orderStatusPage.selected' | translate }}:
          {{ selectedFiltersSummary[filterKey] }}
        </span>
        <span
          *ngIf="
            selectedFiltersSummary[filterKey] !== undefined &&
            filterKey === 'deliveryDate'
          "
        >
          {{ selectedFiltersSummary[filterKey] }}
        </span>
      </ion-label>
    </ion-item>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="clear-all-modal-btn"
        data-cy="clear-all-modal-btn"
        class="usf-outline-green-mobile-modal-button"
        (click)="resetFilters()"
        translate
      >
        {{ 'i18n.common.clearAll' }}
      </ion-button>
      <ion-button
        id="apply-modal-btn"
        data-cy="apply-modal-btn"
        class="usf-fill-green-mobile-modal-button"
        (click)="dismissModal(true)"
        [disabled]="hasIncompleteDateRange"
        translate
      >
        {{ 'i18n.common.apply' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
